var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 23.5,
    stroke: "#7E7DBF",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27C24.1569 27 25.5 28.3431 25.5 30C25.5 31.6568 24.1569 33 22.5 33C20.8431 33 19.5 31.6568 19.5 30C19.5 28.3431 20.8431 27 22.5 27Z",
    stroke: "#29286A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 17C25.8431 17 24.5 18.3431 24.5 20C24.5 21.6568 25.8431 23 27.5 23C29.1569 23 30.5 21.6568 30.5 20C30.5 18.3431 29.1569 17 27.5 17Z",
    stroke: "#29286A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29.957L35 29.957",
    stroke: "#29286A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.957L15 19.957",
    stroke: "#29286A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.957L17 29.957",
    stroke: "#29286A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19.957L33 19.957",
    stroke: "#29286A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.db9c0af47e9be8f87985b78111613dd2.svg";
export { ForwardRef as ReactComponent };